module.exports = __webpack_public_path__ + "img/background.40859560.jpg";